export const brandName = () => window.appBrandName;
export const logoUrl = () => window.appLogoUrl;
export const supportEmail = 'mary@strongrfastr.com';
export const dateFormat = 'YYYY-MM-DD';
export const dateFormatRegex = /^\d{3,5}-\d{2}-\d{2}$/;
export const iosRatingUrl = `itms-apps://itunes.apple.com/app/viewContentsUserReviews/id${window.iosAppId}?action=write-review`;
export const androidRatingUrl = `https://play.google.com/store/apps/details?id=${window.androidPackageName}`;
export const macroColors = {
    protein: '#3fa054',
    fat: '#FF9900',
    carbs: '#3366CC',
    fiber: '#979dac',
    alcohol: '#990099'
}
export const calRoundFactor = 50.0;
export const NUTRITION = 'nutrition';
export const TRAINING = 'training';
export const FULL = 'full';
export const CLEARED_FILTERS = { trainerId: 'me', status: 'active', setup: null, tag: null, goal: null, routineId: null, gender: null, query: ''};
// Cohosted app scope helpers
export const cohostedScope = () => window.cohostedScope || '';
export const cohostedStartPath = () => (window.cohostedStartPath || '').replace(/^\/app/, '');
export const cohostedScopesMap = () => {
    const raw = window.cohostedScopesMap || '';
    if (!raw) return {};
    return Object.fromEntries(raw.split(',').map(pair => pair.split(':')));
};
export const cohostedKeyForScope = (scope) => {
    const map = cohostedScopesMap();
    return Object.entries(map).find(([, id]) => id === scope)?.[0] || '';
};
export const scopeForCohostedKey = (key) => cohostedScopesMap()[key] || '';

export const TPAYWALL = 'trainer_paywall';
export const TSIGNUP = 'trainer_signup';
export const TSIGNUP_CONTEXTS = [TPAYWALL,TSIGNUP];
export const citations = { 
    calories: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3880593', 
    rt: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7068252/', 
    protein: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5470183/', 
    consistency: 'https://ajcn.nutrition.org/article/S0002-9165(23)29536-2/fulltext',
    twiceEffectMuscle: 'https://jissn.biomedcentral.com/articles/10.1186/s12970-017-0177-8',
    twiceEffectLose: 'https://pubmed.ncbi.nlm.nih.gov/28871849/',
    stokesMetabolism: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2931407/#!po=8.33333',
    mortalityRisk: 'https://journals.lww.com/acsm-msse/Fulltext/2018/03000/Associations_of_Muscle_Mass_and_Strength_with.8.aspx',
    intermittentFasting: 'https://pubmed.ncbi.nlm.nih.gov/35276989/',
    mentalHealth: 'https://www.bmj.com/content/384/bmj-2023-075847',
    metTypeHTM: 'https://pubmed.ncbi.nlm.nih.gov/25964395/',
    metTypeSMET: 'https://pubmed.ncbi.nlm.nih.gov/28741280/',
    metTypeHSPM: 'https://pubmed.ncbi.nlm.nih.gov/22065844/',
    metTypeLPRM: 'https://pubmed.ncbi.nlm.nih.gov/9505809/',
    metTypeBMET: 'https://pubmed.ncbi.nlm.nih.gov/15534426/',
    mps: 'https://pubmed.ncbi.nlm.nih.gov/22289911/'
 }